import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '@my-env/environment';
import { UserDetails } from '@my-models/users';
import { AuthService } from '@my-services/auth.service';
import { CommonServiceService } from '@my-services/common-service.service';
import { Constants } from '@my-util/constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = environment.appName;
  isHeaderFooterShow: boolean = false;
  flag: boolean = false;
  bgClassAdded: boolean = false;
  hideHeaderFooter: any = [
    'disclaimers',
    'terms',
    'privacy',
    'aboutus',
    'faqs',
    'ezycare',
    'downloadapp',
  ];

  constructor(
    private _commonService: CommonServiceService,
    private _authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    // window.alert(window.location.pathname);

    for (var linkitem of this.hideHeaderFooter) {
      // alert(linkitem);
      if (window.location.pathname.includes(linkitem)) {
        this.isHeaderFooterShow = false;
        return;
      }
    }

    setTimeout(() => {
      if (
        window.location.pathname == '/' ||
        window.location.pathname == '/a/new-launches/details' ||
        window.location.pathname == '/p/post-view' ||
        window.location.pathname.includes('/p/events-view') ||
        window.location.pathname.includes('/p/property-view/') ||
        window.location.pathname.includes('/broker/plan-subscription') ||
        window.location.pathname === '/register'
      ) {
        this.isHeaderFooterShow = false;
      } else {
        this.isHeaderFooterShow = true;
      }
    }, 1000);

    const refreshInterval = setInterval(() => {
      let data = sessionStorage.getItem('u');
      if (data) {
        this.isHeaderFooterShow = true;
        clearInterval(refreshInterval);
      }
    }, 900);

    const usr: UserDetails = this._authService.getUser();
    if (usr?.location?.lat == 0) {
      this._commonService.getPosition();
    }
    this.AddClassOnHeader();
  }

  // add class on scroll
  @HostListener('window:scroll', ['$event'])
  onScroll() {
    if (window.scrollY > 1) {
      this.flag = true;
      if (window.location.pathname == Constants.DASHBOARD_ROUTE) {
        this.bgClassAdded = true;
      }
    } else {
      this.flag = false;
      if (window.location.pathname == Constants.DASHBOARD_ROUTE) {
        this.bgClassAdded = false;
      }
    }
  }

  AddClassOnHeader() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        event.url !== Constants.DASHBOARD_ROUTE
          ? (this.bgClassAdded = true)
          : (this.bgClassAdded = false);
      }
    });
    window.location.pathname !== Constants.DASHBOARD_ROUTE
      ? (this.bgClassAdded = true)
      : (this.bgClassAdded = false);
  }

  // end
}
